import createHeartComponent from '@finn-no/favorite-heart-component';
import React from 'react';
import ReactDOM from 'react-dom';
import RecommendationsWithFallback from '../../podlet-common/src/RecommendationsWithFallback';
import { LitElement, html } from 'lit';
import { ref, createRef } from 'lit/directives/ref.js';

class WebComponent extends LitElement {
    appRef = createRef();
    initialState: any;

    static get properties() {
        return {
            initialState: { type: Object, attribute: 'initial-state' },
        };
    }

    render() {
        return html`<div>
            <link
                rel="stylesheet"
                type="text/css"
                href="${this.initialState.css}"
            />
            <div ${ref(this.appRef)}></div>
            <section
                data-nosnippet
                aria-label="Anbefalinger"
                id="${this.initialState.type}-podlet-root"
            ></section>
            ${this.initialState.disableBlinkScript
                ? html``
                : html`<script src="https://static.finncdn.no/_c/distribution-fixed/FINNExternalDistribution.js" defer crossorigin></script>`}
        </div>`;
    }

    updated() {
        const Heart = createHeartComponent({
            userId: this.initialState.loginId,
            baseUri: this.initialState.favoritesListUrl,
            modalAttach: this.appRef.value as HTMLElement,
        });

        const isMobile = this.initialState.deviceType !== 'desktop';

        const renderActions = ({ adId, itemType }) => {
            const isFavouritableAd = Boolean(adId);

            return isFavouritableAd ? (
                <Heart
                    itemId={adId}
                    itemType={itemType}
                    isMobile={isMobile}
                    variant="heart-on-image"
                    christmasGiftList={this.initialState.christmasGiftList}
                />
            ) : null;
        };

        const props = {
            ...this.initialState,
            renderActions,
        };

        ReactDOM.render(
            <div>
                <RecommendationsWithFallback
                    {...props}
                    fallbackTitle={this.initialState.fallbackTitle}
                    fallbackProduct={this.initialState.fallbackProduct}
                    forceFallback={false}
                    type="mlt"
                />
            </div>,
            this.appRef.value
        );
    }
}

if (!customElements.get('data-podlet-mlt')) {
    customElements.define('data-podlet-mlt', WebComponent);
}
